import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { JobReferenceDto } from 'src/app/services/api.services';
import { InsightsJobsService, InsightsJobState } from '../../insights-jobs.service';

@Component({
  selector: 'app-job-progress',
  templateUrl: 'job-progress.component.html',
  standalone: false
})
export class JobProgressComponent implements OnDestroy, OnChanges {
  @Input() job: JobReferenceDto = null;
  @Input() jobTitle = 'Job';

  @Output() completed = new EventEmitter<boolean>();

  runningJob = false;
  jobState: InsightsJobState;
  trackerSubscription: Subscription;

  constructor(
    private readonly insightsJobService: InsightsJobsService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnDestroy() {
    this.disposeSubscription();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.job) {
      this.startTracking();
    }
  }

  startTracking() {
    this.disposeSubscription();

    this.completed.emit(false);

    if (this.job) {
      this.trackerSubscription = this.insightsJobService.jobStarted(this.job.id).pipe(
        tap(s => {
          this.jobState = { ...s };

          if (s.completed || s.state.getStateFailed) {
            this.completed.emit(true);

            this.runningJob = false;
          }
          else {
            this.runningJob = true;
          }
        })
      ).subscribe(() => {
        this.changeDetectorRef.detectChanges();
      });
    }
  }

  disposeSubscription() {
    if (this.trackerSubscription) {
      this.trackerSubscription.unsubscribe();
      this.trackerSubscription = null;
    }
  }
};

